import { Box, MenuItem, Modal, Slide } from "@mui/material"
import { Download, DownloadPDF } from "../../../../../../core/transmit/S3"
import Pdf from '../../../../../../assets/images/icons/pdficon.png'
import IMG from '../../../../../../assets/images/icons/imageicon.png'

export const DownloadRegs = ({show, message, successOpen, regActive}) => {
    const btnList = [
        {name: 'PDF', icon: Pdf, type: 'pdf'},
        {name: 'Image', icon: IMG, type: 'img'},
    ]

    const handlerCloseMenu = () => {
        setTimeout(() => {
            show.set({...show.data, download:false})
        }, 200);
    }
    
    const handlerMenuBtn = async(e, type) => {
        if (type === 'pdf') {
            let res = await DownloadPDF(show.data.data.file_link, show.data.data.file_name)
            if (res === 'success') {
                regActive.set({...regActive.data, openMenu: null})
                message.set('Successfully download')
                successOpen.set(true)
            }
        }else{
            let res = await Download(e, show.data.data.file_link, show.data.data.file_name)
            if (res === 'success') {
                regActive.set({...regActive.data, openMenu: null})
                message.set('Successfully download')
                successOpen.set(true)
            }
        }
    }
    
    return (
        <Modal open={show.data.download} onClose={() => handlerCloseMenu()} BackdropProps={{ sx: {bgcolor: '#0000001F'} }} sx={{zIndex: 1303}}>
            <Slide in={show.data.download} direction="up">
                <Box height="100%" width="100%" display="flex" justifyContent="flex-end" flexDirection="column">
                    <Box height="100%" onClick={() => handlerCloseMenu()} />
                    <Box minHeight={"112px"} bgcolor="#FFFFFF" p={2}
                        borderRadius="16px 16px 0px 0px" boxShadow="0px 0px 24px rgba(0, 0, 0, 0.08)"
                    >
                        {
                            (show.data.view ? btnList.filter(v => { return v.type !== 'view'}) : btnList).map((v,k) => (
                                <MenuItem sx={{px: '0px', py: '8px', minHeight: '36px'}} key={k} onClick={(e) => handlerMenuBtn(e, v.type)}>
                                    <img src={v.icon} alt="" />
                                    <Box ml="12px" fontSize={14} fontWeight={400} lineHeight="22px">{v.name}</Box>
                                </MenuItem>
                            ))
                        }
                    </Box>
                </Box>
            </Slide>
        </Modal>
    )
}